"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryWalk = void 0;
class HistoryWalk {
    constructor(direction, initial, fragment, filter) {
        this.direction = direction;
        this.fragment = fragment;
        this.visited = new Set();
        this.queue = [];
        this.queueContents = new Set();
        this.filter = filter;
        for (const hash of initial.values()) {
            if (this.fragment.contents.has(hash) && (filter === undefined || filter(hash))) {
                this.enqueueIfNew(hash);
            }
        }
    }
    [Symbol.iterator]() {
        return this;
    }
    enqueueIfNew(what) {
        if (!this.visited.has(what) && !this.queueContents.has(what)) {
            this.enqueue(what);
        }
    }
    enqueue(what) {
        this.queue.push(what);
        this.queueContents.add(what);
    }
    dequeue() {
        const result = this.queue.shift();
        this.queueContents.delete(result);
        return result;
    }
    goFrom(opHistoryHash) {
        let unfiltered;
        if (this.direction === 'forward') {
            unfiltered = this.goForwardFrom(opHistoryHash);
        }
        else {
            unfiltered = this.goBackwardFrom(opHistoryHash);
        }
        if (this.filter === undefined) {
            return unfiltered;
        }
        else {
            const filtered = new Set();
            for (const hash of unfiltered.values()) {
                if (this.filter(hash)) {
                    filtered.add(hash);
                }
            }
            return filtered;
        }
    }
    goForwardFrom(opHistoryHash) {
        return this.fragment.nextOpHistories.get(opHistoryHash);
    }
    goBackwardFrom(opHistoryHash) {
        const history = this.fragment.contents.get(opHistoryHash);
        if (history !== undefined) {
            return history.prevOpHistories;
        }
        else {
            return new Set();
        }
    }
}
exports.HistoryWalk = HistoryWalk;
//# sourceMappingURL=HistoryWalk.js.map